<template>
    <transition name="transform">
        <div v-if="visible"
            :class="['visual-panel', {'visual-panel_theme_flat': dataStep.step === 'flat', 'is-mobile-horizontal': isMobileHorizontal}]">
            <div class="visual-panel__container">
                <div class="visual-panel__header">
                    <div class="visual-panel__title h5" v-html="panel.title"></div>
                    <div v-if="panel.isBooked && !panel.isSold" class="visual-panel__booked">
                        <iconLock className="visual-panel__booked-icon"/>
                        Поставлен резерв
                    </div>
                    <div v-if="panel.size" class="accent" v-html="panel.size">></div>

                    <button class="visual-panel__close" @click="remove">
                        <iconClose/>
                    </button>
                </div>
                <div class="visual-panel__info">
                    <div v-if="panel.comment" class="visual-panel__comment accent" v-html="panel.comment"></div>
                    <ul v-if="dataStep.step !== 'flat'" class="visual-panel__params">
                        <li
                            v-for="(item, index) in panel.params"
                            v-if="!item.disabled"
                            :key="index"
                            class="visual-panel__params-item">

                            <div v-if="item.flats" class="visual-panel__name" v-html="item.flats"></div>
                            <div v-if="item.amount" class="visual-panel__amount" v-html="item.amount"></div>

                            <div v-if="item.price && !item.requirePrice"
                                class="visual-panel__value">
                                от {{ convertPriceRank(item.price) }} млн ₽
                            </div>
                            <div v-if="item.price && item.requirePrice"
                                 class="visual-panel__value">
                                Цена по запросу
                            </div>
                        </li>
                    </ul>

                    <!-- Данные планировок -->
                    <ul v-if="dataStep.step === 'flat' && !panel.isSold" class="visual-panel__params">
                        <li v-if="panel.type" class="visual-panel__params-item">
                            <div class="visual-panel__name">Тип</div>
                            <div class="visual-panel__value" v-html="panel.type"></div>
                        </li>
                        <li v-if="panel.area" class="visual-panel__params-item">
                            <div class="visual-panel__name">Площадь</div>
                            <div class="visual-panel__value">{{ panel.area }} м²</div>
                        </li>
                        <li v-if="panel.price" class="visual-panel__params-item">
                            <div v-if="isNumber(panel.price)" class="visual-panel__name">Цена при 100% оплате</div>
                            <div class="visual-panel__value accent">
                                {{ isNumber(panel.price) ? `${convertPriceDigit(panel.price)} ₽` : panel.price }}
                            </div>
                        </li>
                        <li v-if="panel.add_pay && $dataset.propertyType === 'parking'"
                            class="visual-panel__params-item">
                            <div class="visual-panel__add-pay">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="8" cy="8.5" r="7" fill="#B98F4F" stroke="#B98F4F"/>
                                    <path d="M8.84809 10.64H7.15309L7.00309 2.75H8.99809L8.84809 10.64ZM9.02809 14H6.97309V11.945H9.02809V14Z" fill="white"/>
                                </svg>
                                <span>{{panel.add_pay}}</span>
                            </div>
                        </li>
                    </ul>
                </div>
                <div v-if="panel.link && panel.linkText" class="visual-panel__next">
                    <button type="button" class="button button_width_block" @click="toNextStep(panel.link)">
                        <span class="button__inner">
                            <span class="button__text" v-html="panel.linkText"></span>
                        </span>
                    </button>
                </div>
            </div>
            <div v-if="panel.linkText && (panel.link || $dataset.propertyType === 'parking')"
                 class="visual-panel__next">
                <button v-if="$dataset.propertyType === 'parking' && dataStep.step === 'flat'"
                        class="visual-panel__next-button j-popup-callback"
                        data-href="booking-flat"
                        data-no-hash="true"
                        :data-inputs="`flatId:${panel.id}`"
                        v-html="panel.linkText"></button>
                <button v-else
                        class="visual-panel__next-button"
                        @click="toNextStep(panel.link, panel.externalId)"
                        v-html="panel.linkText"></button>
            </div>
        </div>
    </transition>
</template>

<style lang="scss">
    @import "./Panel.scss";
</style>

<script>
import iconClose from '../Icons/icon-close';
import iconLock from '../Icons/icon-lock';
import {mapGetters} from 'vuex';
import Observer from 'common/scripts/observer';
import sendFlatPostMessage from '@/helpers/sendFlatIdPostMessage';
import {Utils} from 'common/scripts/utils';

const observer = new Observer();

export default {
    data() {
        return {
            visible: false
        };
    },

    props: {
        isMobileHorizontal: Boolean
    },

    components: {
        iconClose,
        iconLock
    },

    computed: {
        ...mapGetters({
            dataStep: 'GET_DATA_STEP'
        })
    },

    watch: {
        dataStep() {
            this.remove();
        }
    },

    mounted() {
        observer.subscribe('mouseoverPanel', (data) => {
            if (this.visible) {
                this.remove();
            }
            this.insert();
            this.setData(data);
        });

        observer.subscribe('mouseleavePanel', () => {
            this.remove();
        });
    },

    methods: {
        insert() {
            this.visible = true;
        },

        remove() {
            this.visible = false;
        },

        setData(data) {
            const targetId = Number(data.id);

            const currentData = data.elements.find((element) => {
                const id = Number(element.id);

                return id === targetId ? element : false;
            });

            this.panel = {
                id        : targetId,
                externalId: data.externalId || null,
                type      : data.type,
                link      : data.link || false,
                ...currentData.tooltip
            };
        },

        convertPriceRank(price) {
            return Utils.convertToDigit(Utils.convertToRank(price, 1000000).toFixed(2));
        },

        convertPriceDigit(price) {
            return Utils.convertToDigit(price);
        },

        toNextStep(link, externalId = null) {
            if (this.$route.query.profitbase && externalId) {
                sendFlatPostMessage(externalId);

                return;
            }
            observer.publish('clickNextPanel', link);
        },

        isNumber(value) {
            return !isNaN(Number(value));
        }
    }
};
</script>
